'use strict';

const ScriptInjector = {

    /**
     * [inject description]
     * @param  {String} url     Url of the script
     * @param  {Object} params  Parameters passed to script loading url
     * @return {Promise}
     */
    inject(url, params = { async: true }) {
        return new Promise((resolve) => {
            let prop;

            const script = document.createElement('script');
            script.src = url;

            for (prop in params) {
                if (params.hasOwnProperty(prop)) {
                    script[prop] = params[prop];
                }
            }

            if (script.readyState) {
                // IE
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        resolve();
                    }
                };
            } else {
                // Others
                script.onload = function () {
                    resolve();
                };
            }

            const scriptTag = document.getElementsByTagName('script')[0];
            scriptTag.parentNode.insertBefore(script, scriptTag);
        });
    }

};

module.exports = ScriptInjector;



// WEBPACK FOOTER //
// ./src/utils/scriptInjector.js